"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformMultiInstanceDisplayModule = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformModulePinConnection_1 = require("./TransformModulePinConnection");
class TransformMultiInstanceDisplayModule extends TransformObject_1.TransformObject {
    constructor(parent, props, component) {
        super(parent, {
            modProps: props,
            component,
            pinConnections: new Set(),
        }, `${parent.deduplicationKey}:midm::${props.ref}`, new Set([TransformModulePinConnection_1.TransformModulePinConnection]));
    }
    add(child) {
        this.assertCanAdd(child);
        this._sharedData.pinConnections.add(child);
    }
    get dependencies() {
        return [this._sharedData.component];
    }
    compile() {
        const pinNets = Object.fromEntries(Array.from(this._sharedData.pinConnections).map((child) => [child.compiled.connection.pinRef, child.compiled.netRef.strCast()]));
        return {
            layer: 'F',
            ...this._sharedData.modProps,
            componentRef: this._sharedData.component.compiled.name,
            pinNets,
        };
    }
}
exports.TransformMultiInstanceDisplayModule = TransformMultiInstanceDisplayModule;
//# sourceMappingURL=TransformMultiInstanceDisplayModule.js.map